import { produce } from 'immer'
import {
  ORG_EXPENSE_REPORTS_QK,
  ORG_USAGES_QK,
  transactionsQueryKeys,
  userQueryKeys,
  virtualCardsQueryKeys,
} from 'src/queries/queries.constants'
import { queryClient } from 'src/queryClient'
import {
  GET_CSP_ME_SUCCESS,
  GET_ME_SUCCESS,
} from 'src/redux/actions/auth.actions'
import { GET_ASYNC_TRANSACTION_UPDATE_JOB_STATUS_COMPLETE } from 'src/redux/actions/data/transactions.actions'
import { PATCH_USER_SUCCESS } from 'src/redux/actions/data/users.actions'
import {
  POST_VIRTUAL_CARD_SUCCESS,
  PUT_CLOSE_VIRTUAL_CARD_SUCCESS,
  PUT_VIRTUAL_CARD_CANCEL_SUCCESS,
  PUT_VIRTUAL_CARD_CANCEL_UPDATE_SUCCESS,
  PUT_VIRTUAL_CARD_REJECT_SUCCESS,
  PUT_VIRTUAL_CARD_SUCCESS,
} from 'src/redux/actions/data/virtualCards.actions'
import { Actions } from 'src/redux/reducers/data.reducer'

const ReactQueryInteropReducer = (
  state: Record<string, never> = {},
  action: Actions,
): Record<string, never> => {
  return produce(state, (_) => {
    switch (action.type) {
      case PUT_VIRTUAL_CARD_CANCEL_SUCCESS:
      case PUT_CLOSE_VIRTUAL_CARD_SUCCESS:
      case PUT_VIRTUAL_CARD_CANCEL_UPDATE_SUCCESS:
      case PUT_VIRTUAL_CARD_REJECT_SUCCESS:
      case PUT_VIRTUAL_CARD_SUCCESS:
      case POST_VIRTUAL_CARD_SUCCESS: {
        // TODO: we will need to save the resulting virtual card to the query store manually
        // because of timing issues with SpiceDB when attempting to immediately refetch paginated views
        queryClient.invalidateQueries({ queryKey: virtualCardsQueryKeys.all })
        // Active virtual-card count drives SaaS limit gating — refetch after any
        // VC create/close/cancel so the downgrade meter sees the latest count.
        // Only invalidate when an org-usages query is already cached (i.e. the
        // user is on a SaaS-enabled brand and a consumer has mounted it).
        // Without this gate, non-SaaS brands trigger a wasted /saas/{orgId}/usages
        // refetch (the endpoint 404s) on every VC mutation app-wide.
        const usagesAlreadyCached = queryClient
          .getQueryCache()
          .findAll({
            predicate: (q) => q.queryKey.includes(ORG_USAGES_QK),
          })
          .some((q) => q.state.data !== undefined)
        if (usagesAlreadyCached) {
          queryClient.invalidateQueries({
            predicate: (query) => query.queryKey.includes(ORG_USAGES_QK),
          })
        }
        break
      }
      case PATCH_USER_SUCCESS: {
        queryClient.invalidateQueries({ queryKey: userQueryKeys.all })
        break
      }
      case GET_ME_SUCCESS: {
        // Only invalidate React Query cache when the action comes from Redux
        // (not from React Query's own onSuccess callback, which already has fresh data)
        if (action.meta?.source !== 'react-query') {
          queryClient.invalidateQueries({ queryKey: userQueryKeys.me() })
        }
        break
      }
      case GET_CSP_ME_SUCCESS: {
        queryClient.invalidateQueries({ queryKey: userQueryKeys.me() })
        break
      }
      case GET_ASYNC_TRANSACTION_UPDATE_JOB_STATUS_COMPLETE: {
        // must refresh all data when a bulk update completes since the data isnt returned
        // and there is no way to know what was updated
        queryClient.invalidateQueries({ queryKey: [ORG_EXPENSE_REPORTS_QK] })
        queryClient.invalidateQueries({ queryKey: transactionsQueryKeys.all })
        break
      }
    }
  })
}

export default ReactQueryInteropReducer
